if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        if ($('#accent-blue').prop("checked")) {
          const textVal = $('.pdp-input-checkbox').val();
          const fontText = $('input[name="font"]:checked').val();
          const locationText = $('input[name="location"]:checked').val();
  
          formData.append('properties[text]', textVal);
          formData.append('properties[font]', fontText);
          formData.append('properties[location]', locationText);
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

function submitProductForm() {
  const productForm = document.querySelector('product-form');
  if (productForm) {
    productForm.onSubmitHandler(new Event('submit'));
  }
}

$(document).ready(async function (params) {
  const productData = await fetch(window.location.href.split('?')[0] + '.json');
  const res = await productData.json();
  const variantData = res.product.variants;
  $('.accent-blue').on('change', function () {
    $('.pdp-checkbox-detail').toggleClass('active');
    let obj = null;
    const engraveElement = $('select[name="options[Engravement]"]').length ? $('select[name="options[Engravement]"]') : $('select[name="options[engravement]"]');
    if ($(this).prop('checked')) {
      engraveElement.val('yes').change();
      if (document.querySelector('variant-selects')) {
        obj = variantData.find((data) => data.option1 === 'yes');
      }
    } else {
      engraveElement.val('no').change();
      if (document.querySelector('variant-selects')) {
        obj = variantData.find((data) => data.option1 === 'no');
      }
    }
    if (document.querySelector('[data-type="add-to-cart-form"] input[name="id"]') && obj) {
      document.querySelector('[data-type="add-to-cart-form"] input[name="id"]').value = obj.id;
      $('.pdp-price span.price-item:visible').text(`${obj.price} ${$('.pdp-price span.price-item:visible').text().trim().split(' ')[1]}`)
    }
    const searchParams = new URLSearchParams(window.location.search);

    // Set or update a parameter in the search query
    searchParams.set('variant', obj.id);

    // Replace the current search query with the updated one
    window.history.replaceState({}, '', `${window.location.pathname}?${searchParams}`);

  });

  $('.product-form__submit').click(async function(event) {
    if ($('#accent-blue').prop("checked")) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      window.stop();
      submitProductForm();
    }
  });

  $('.fonts-multi-btn button.pdp-fonts-btn').on('click', function () {
    $('.fonts-multi-btn button.pdp-fonts-btn').removeClass('active');
    $(this).addClass('active');
    $(this).find('input:radio').attr('checked', true);
  });

  $(".pdp-location-btn").change(function(){
    const selectedValue = $(this).val();
    $('.pdp-location-btn').removeClass('active');
    $(this).addClass('active');
    $("#display-label").text(selectedValue);
  });

});

